const initMediaTextSwitcher = (switcher) => {
    const elements = switcher.querySelectorAll('.media-text-switcher-element');
    const desktopMedia = switcher.querySelectorAll('.media-text-switcher__desktop-media > div');
    elements.forEach((element) => {
        element.addEventListener('click', () => {
            let activeElementIndex = 0;
            elements.forEach((currentElement, index) => {
                if (element === currentElement) {
                    activeElementIndex = index;
                }
                currentElement.classList.toggle('active', element === currentElement);
            });
            desktopMedia.forEach((currentElement, index) => currentElement.classList.toggle('active', index === activeElementIndex));
        });
    });
};
export const initMediaTextSwitchers = () => {
    const switchers = document.querySelectorAll('.media-text-switcher');
    if (switchers.length === 0) {
        return;
    }
    switchers.forEach((switcher) => initMediaTextSwitcher(switcher));
};
